export default {
	tableSearch: 'Rechercher',
	nbRowText: '0 {item} | 1 {item} | {count} {item}s',
	deleteDialogTitle: ' {singular} | {plural}',
	successDeleteMessage: '{singular} | {plural}',
	selectedItems: '0 {singular} | 1 {singular} | {count} {plural}',
	btnSearch: 'Rechercher',
	cancel: 'RETOUR',
	headerAction: {
		align: 'left',
		sortable: false,
		value: 'action'
	},
	errors: {
		outOfRangePage: 'Aucun résultat à afficher sur la page sélectionnée.'
	}
};
